<div class="display-layout-column layout-gap-15">
  <span> Do you want to proceed with the deletion? </span>

  <div class="display-layout-row layout-gap-15 justify-content-end align-items-center">

    <button mat-button (click)="onNoClick()">No</button>

    <button mat-stroked-button (click)="onYesClick()">Yes</button>
  </div>
</div>
